import styles from './Toolbar.module.scss';

interface Props {
  search: string;
  onSearch: (q: string) => void;
}

export default function Toolbar({ search, onSearch }: Props) {
  return (
    <div className={styles.toolbar}>
      <div className={styles.searchWrap}>
        <svg
          className={styles.searchIcon}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <circle cx="11" cy="11" r="8" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
        <input
          type="text"
          className={styles.searchInput}
          placeholder="Search by name, date, or any column…"
          value={search}
          onChange={e => onSearch(e.target.value)}
          aria-label="Search rows"
        />
      </div>
    </div>
  );
}
